import { actionTypes } from '../actions/plans';
import { plans as defaultState } from './default.json';

const handlers = {
  [actionTypes.PLANS_SET_SELECTED]: (state, action) => ({
    ...state,
    selectedPlan: action.selectedPlan,
  }),
  [actionTypes.PLANS_CLEAR_SELECTED]: () => ({
    ...defaultState,
  }),
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
